import { getProxyOsPrepay, postProxyOsPrepay } from '../../../../ui-kitchen/src/api/api';
import Logger from '../../../../ui-kitchen/src/utils/logger';

angular
  .module('resyApp')
  .service('Prepay', Prepay);

function Prepay($q) {
  const prepayData = {};

  function get(token) {
    return $q((resolve, reject) => {
      if (typeof prepayData[token] === 'object') {
        resolve(angular.copy(prepayData[token]));
      } else {
        getProxyOsPrepay({ token }).then((response) => {
          prepayData[token] = response;
          resolve(angular.copy(response));
        }).catch((reason) => {
          reject(reason);
        });
      }
    });
  }

  function submit(token, data) {
    return postProxyOsPrepay({ ...data, token })
      .then(({ data: response }) => {
        prepayData[token] = response;
      })
      .catch((error) => {
        Logger.error('[CATCH] Prepay Service submit: ', error);
        throw (error);
      });
  }

  return {
    get,
    submit,
  };
}

export default () => {};
